const $$splitComponentImporter = () => import('/src/src/routes/_cms/cms/tools/review_settings.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_cms/cms/tools/review_settings")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Review Settings",
      description: "Page title for CMS review settings configuration"
    })
  }
});